<template>
  <div>
    <header-nav v-if="showHeader && routerState"></header-nav>
    <div class="page-box">
      <router-view :class="[{'mar-auto':isCenter}]" v-if="routerState"></router-view>
    </div>
    <page-footer v-if="showHeader"></page-footer>
    <div class="float-box" v-if="isChat">
      <div class="lianxi hand">
        <div class="weixin-box">
          <img src="../src/assets/weixin.png" alt="">
          <div class="block-box">
            <div class="wchat" :style="{background: `url(${user.photo}) round`,backgroundSize: '100% 100%'}"></div>
            <div>扫码添加微信公众号</div>
          </div>
        </div>
        <el-divider></el-divider>
        <div class="qq-box" @mouseenter="mouseEnter" @mouseleave="mouseOut">
          <img src="../src/assets/kefu.png" alt="">
          <div class="phone qq-txt" v-if="showQq" @mouseleave="mouseOut">
            <!-- <img src="../src/assets/qq.png" alt=""> -->
            <div class="txt">
              邮箱：{{user.qqNumber}}
            </div>
          </div>
        </div>
      </div>
      <div class="phone">
        <img src="../src/assets/phone.png" alt="">
        <div class="txt">
          手机：{{user.phone}}
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import headerNav from './components/headerNav'
  import pageFooter from './components/pageFooter'
  export default {
    name: 'App',
    components: {
      headerNav,
      pageFooter
    },
    provide() {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        showHeader: true,
        isCenter: true,
        isChat: true,
        showQq: false,
        user: {},
        routerState: true
      }
    },
    watch: {
      '$route'(to) {
        const arr = ['/login', '/', '/courseList', '/videoDetail', '/lookVideo']
        this.showHeader = to.path !== '/login';
        this.isChat = to.path !== '/onChat';
        console.log('app刷新', to.path, arr.includes(to.path))
        if (!arr.includes(to.path)) {
          this.isCenter = true
        } else {
          this.isCenter = false
        }
      }
    },
    created() {
      this.getSer();
    },
    methods: {
      mouseEnter() {
        this.showQq = true
      },
      getSer() {
        let data = {
          id: '222544a233224a8f92963f2eff646a8a'
        }
        this.$http.getService(data).then(res => {
          this.user = res.data
        })
      },
      mouseOut() {
        this.showQq = false
      },
      reload() {
        this.routerState = false;
        this.$nextTick(() => {
          this.routerState = true;
        })
      }
    }
  }
</script>

<style lang="scss">
  .page-box {
    font-family: 'SourceHanSansCN-Medium', 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333333;
    font-size: 16px;
    min-height: 100vh;
    background: #F6F8FA;
  }

  .el-breadcrumb__inner a,
  .el-breadcrumb__inner.is-link {
    font-weight: 400 !important;
  }

  .el-breadcrumb__item:last-child .el-breadcrumb__inner,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
    font-weight: 700 !important;
  }

  .el-progress-bar {
    padding-right: 60px !important;
    width: 100%;
    margin-right: -66px !important;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -webkit-touch-callout: none;
    /*系统默认菜单被禁用*/
    user-select: none;
  }

  .mar-auto {
    max-width: 1200px;
    margin: 0 auto;
  }

  .hand {
    cursor: pointer;
  }

  .float-box {
    position: fixed;
    bottom: 50px;
    right: 20px;
    text-align: right;

    .lianxi {
      display: inline-block;
      height: 190px;
      padding: 20px;
      background: #FFFFFF;
      box-shadow: 0px 0px 21px 0px rgba(8, 93, 196, 0.1);
      border-radius: 4px;
      margin-bottom: 15px;

      .weixin-box {
        position: relative;
        text-align: center;

        &:hover {
          .block-box {
            display: block;
          }
        }

        .block-box {
          display: none;
          position: absolute;
          right: 80px;
          bottom: -80px;
          padding: 15px;
          background: #FFFFFF;
          box-shadow: 0px 0px 21px 0px rgba(8, 93, 196, 0.1);
          border-radius: 4px;
          color: #999999;
          font-size: 14px;

          .wchat {
            width: 149px;
            height: 153px;
            background: #999999;
          }
        }
      }

      .qq-box {
        position: relative;
        text-align: center;

        .qq-txt {
          position: absolute;
          right: 80px;
          top: 0;
        }
      }
    }

    .phone {
      width: 190px;
      height: 50px;
      background: #FFFFFF;
      box-shadow: 0px 0px 21px 0px rgba(8, 93, 196, 0.1);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;

      .txt {
        color: #999999;
        font-size: 14px;
        margin-left: 10px;
      }
    }
  }

  .el-input__inner {
    font-size: 16px;
  }

  .el-input-group__prepend {
    width: 105px;
    font-size: 16px;
    background-color: #ffffff;
  }

  .el-input-group__append {
    width: 121px;
    font-size: 16px;
    background-color: #ffffff;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #26C2DC !important;
    background-color: #26C2DC !important;
  }

  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: inherit !important;
  }

  .el-checkbox__inner:hover {
    border-color: #26C2DC !important;
  }

  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #26C2DC !important;
  }

  .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }

  .el-checkbox__inner::after {
    left: 6px;
    top: 1px;
    width: 6px;
    height: 12px;
  }

  /* // 滚动条整体粗细样式 */
  ::-webkit-scrollbar {
    /* // 高宽分别对应横竖滚动条的尺寸 */
    width: 8px;
    height: 8px;
  }

  /* // 滚动条里面滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 8px !important;
    /* // 通过设置边框达到滑块在轨道中间的效果 */
    border: 3px solid #E5E5E5;
    /* 颜色 */
    background: #E5E5E5 !important;
  }

  /* // 滚动条轨道 */
  ::-webkit-scrollbar-track {
    background: #FFFFFF !important;
  }

  .ice-title {
    padding-top: 40px;
    padding-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    .line {
      width: 130px;
      height: 1px;
      background: #D8D8D8;
      opacity: 0.69;
    }

    .text {
      font-size: 32px;
      font-weight: bold;
      margin: 0 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue